"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _WebMessenger = require("./WebMessenger");
Object.keys(_WebMessenger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WebMessenger[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WebMessenger[key];
    }
  });
});
